import { MAIN_STAGE } from '../main-stage';
import type { SetDefinition, SpawnRule } from '../types';

// Beyond the Dome giants' arms, which leave no room for a whole speaker, and the Ambyss guy ropes.
const CORNER_SPEAKER_SPOTS: Record<string, { x: number; y: number }> = {
  'dome-chill': { x: 1430, y: 260 },
  foret: { x: 1430, y: 740 },
  'cercle-acid': { x: 170, y: 740 },
  sub: { x: 170, y: 260 },
};

export const inCorners = (speakers: SetDefinition['speakers']) =>
  (speakers ?? []).map((speaker) => ({ ...speaker, ...CORNER_SPEAKER_SPOTS[speaker.id] }));

// Slower bars would send fewer bad vibes a second; a single one stays, to keep a period dividing a phrase.
const denser = (rules: readonly SpawnRule[], pressure: number): SpawnRule[] =>
  rules.map((rule) =>
    rule.count > 1 ? { ...rule, count: Math.round(rule.count * pressure) } : rule,
  );

export const denserTiers = (pressure: number): SetDefinition['tiers'] =>
  MAIN_STAGE.tiers.map((tier) => ({
    ...tier,
    spawns: denser(tier.spawns, pressure),
    ...(tier.dropSpawns && { dropSpawns: denser(tier.dropSpawns, pressure) }),
  }));
